'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RelatedProducts = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

require('slick-carousel');

var _pcSlateTools = require('./../../process/pc-slate-tools');

var _CarouselSection2 = require('./../carousel/CarouselSection');

var _ShopifySection = require('./../ShopifySection');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTAINER_SELECTOR = '[data-related-products]'; /*
                                                     *  Related Products Carousel
                                                     *    Scripts for the related products carousel utilising Slick.
                                                     *
                                                     *
                                                     *  Version:
                                                     *    1.0.0 - 2020/08/12
                                                     */

var CAROUSEL_SELECTOR = '[data-related-products-loop]';

var RelatedProducts = exports.RelatedProducts = function (_CarouselSection) {
  (0, _inherits3.default)(RelatedProducts, _CarouselSection);

  function RelatedProducts(container) {
    (0, _classCallCheck3.default)(this, RelatedProducts);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RelatedProducts.__proto__ || Object.getPrototypeOf(RelatedProducts)).call(this, container));

    _this.container = container;
    _this.carouselSelector = container.find(CAROUSEL_SELECTOR);
    _this.productId = container.attr('data-product-id');

    _this.fetchRelatedProducts();
    //$(document).on(ON_CART_FINISHED, e => this.fetchRelatedProducts());
    return _this;
  }

  (0, _createClass3.default)(RelatedProducts, [{
    key: 'fetchRelatedProducts',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var relatedTemplate, data, i, c, product, variant, templ, image;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                relatedTemplate = this.container.find('[data-related-products-thumbnail]').html();

                // if(this.slick) {
                //   this.carouselSelector.slick('unslick');
                //   this.carouselSelector.html('');
                // }

                // await new Promise(resolve => setTimeout(resolve, 100));

                //Fetch recommended products based on Shopify Recommended Product API.

                _context.next = 3;
                return fetch('/recommendations/products.json?product_id=' + this.productId + '&limit=10').then(function (data) {
                  return data.json();
                });

              case 3:
                data = _context.sent;

                if (!(!data || !data.products)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return');

              case 6:
                this.carouselSelector.html('');

                i = 0, c = 0; //i = index of current product, c = count of products printed

              case 8:
                if (!true) {
                  _context.next = 29;
                  break;
                }

                if (!(i >= data.products.length || c >= this.relatedCount)) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt('break', 29);

              case 11:
                product = data.products[i++];

                if (product.available) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt('continue', 8);

              case 14:
                //Is unavailable?

                variant = product.variants.find(function (v) {
                  return v.available;
                }) || product.variants.find(function (v) {
                  return v;
                });
                templ = $(relatedTemplate).appendTo(this.carouselSelector);


                templ.find('[data-variant-id]').attr('data-variant-id', variant.id);
                image = variant.featured_image && variant.featured_image.src ? variant.featured_image.src : product.featured_image;

                templ.find('[data-url]').attr('href', product.url);
                templ.find('[data-image]').html((0, _pcSlateTools.generatePicture)(image, 300, [150, 300]));
                templ.find('[data-title]').text(product.title);
                templ.find('[data-sku]').text(variant.sku);
                templ.find('[data-pull-force]').text(product.pull_force);
                this.printOptions(templ.find('[data-options]'), variant.options);
                this.printPrice(templ.find('[data-price]'), variant.price);
                this.printCompare(templ.find('[data-compare-price]'), variant.price, variant.compare_at_price);
                c++;
                _context.next = 8;
                break;

              case 29:

                //Were there any related items?
                if ((this.carouselSelector.html() || '').replace(/\s/g, '').length) {
                  //Initialise carousel
                  this.slick = this.initCarousel(this.carouselSelector);
                  this.container.addClass('has-items');
                } else {
                  this.container.removeClass('has-items');
                }

              case 30:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchRelatedProducts() {
        return _ref.apply(this, arguments);
      }

      return fetchRelatedProducts;
    }()
  }, {
    key: 'printOptions',
    value: function printOptions(el, options) {
      el.text(options.filter(function (o) {
        return o != 'Default Title';
      }).join(', '));
    }
  }, {
    key: 'printPrice',
    value: function printPrice(element, price) {
      element.html((0, _pcSlateTools.printMoney)(price)).attr('data-money', price).attr('data-currency', '');
    }
  }, {
    key: 'printCompare',
    value: function printCompare(element, price, compare) {
      if (compare > price) {
        this.printPrice(element, compare);
      } else {
        element.html('').removeAttr('data-money').removeAttr('data-currency');
      }
    }
  }]);
  return RelatedProducts;
}(_CarouselSection2.CarouselSection);

(0, _ShopifySection.register)(CONTAINER_SELECTOR, RelatedProducts);